<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-1">
        <v-col cols="3">
          <multi-level-select v-if="categories.length" :menuData="categoryItems" :second.sync="itemId" @change="saveParms()" outlined label="Item" hide-details/>
          <v-autocomplete v-else :items="items" item-text="name" item-value="id" v-model="itemId" dense @change="saveParms()" outlined label="Item" hide-details/>
        </v-col>
        <v-col cols="3">
          <v-autocomplete label="Spirit" dense outlined hide-details :items="spirits" v-model="spiritId" item-text="name" item-value="id" @change="saveParms()"/>
        </v-col>
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="saveParms()" hide-details option="All" allow-all/>
        </v-col>
        <v-col cols="2">
          <v-autocomplete label="By" dense outlined hide-details v-model="frequency" @change="saveParms()"
                    :items="[{value:'Day',text:'Day'},{value:'Week',text:'Week'},{value:'Month',text:'Month'},{value:'Quarter',text:'Quarter'},{value:'Year',text:'Year'},{divider:true},{value:'Lot',text:'Lot'}]"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="print"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
      <!--
      <v-row dense class="pb-0">
        <v-col class="text-center" cols="3">
          <v-btn-toggle rounded v-model="display" mandatory class="mt-1" @change="display===1?buildGraph():''">
            <v-btn small><v-icon small>mdi-format-list-bulleted</v-icon></v-btn>
            <v-btn small><v-icon small>mdi-chart-line</v-icon></v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      -->
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 184px)">
      <div v-if="display===0" v-html="report()"/>
      <div v-else style='width:100%;text-align:center'>
         <div class="title">{{item.name}} - to ${{spirit.name}} yield</div>
         <div class="sub-title">{{dateDisplay}}</div>
        <div ref="chart" style="height:400px"/>
      </div>
    </v-card>

  </div>
</template>

<script>
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'
import googleCharts from '@/mixins/googleCharts'
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'ReportsItemToSpirit',
  mixins: [printHtml,googleCharts,createHierarchyList],
  data() {
    return {
      from: localStorage.getItem('reportsItemToSpirit.from'),
      to: localStorage.getItem('reportsItemToSpirit.to'),
      dateDisplay: '',
      categories: [],
      items: [],
      itemId: null,
      spirits: [],
      spiritId: null,
      frequency: localStorage.getItem('reportsItemToSpirit.frequency') ?? 'Year',
      display: 0,
      graph: '',
      data: [],
      chart: null,
      loading: true,
      options: {chartArea:{height:'70%',width:'85%'},
                fontSize:12,
                vAxis:{format: '#,###.0', title:"Percent of input",gridlines:{color:'#ddd'},minorGridlines:{count:0}},
                hAxis:{slantedText:true},
                series: {
                  0: {color:'#00f'},
                  1: {color:'#080',lineWidth:1},
                  2: {color:'#0f0',lineDashStyle:[5,5],lineWidth:1},
                  3: {color:'#0f0',lineDashStyle:[5,5],lineWidth:1},
                },
                legend:{ position: "none"}}
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    categoryItems() {
      const categories = this.createHierarchyList(this.categories);
      for (const category of categories) {
        const sub = this.items.filter(item => item.category?.id === category.id);
        if (sub.length)
          category.menu = sub;
        else
          category.disabled = true;
      }
      const items = categories;
      const leftOver = this.items.filter(item => !item.category?.id);
      if (leftOver.length)
        items.push({divider:true},{name:'Other items',id:'x',menu:leftOver});
      return items;
    },
    item() {
      return this.items.find(item => item.id === this.itemId) || {};
    },
    spirit() {
      return this.spirits.find(spirit => spirit.id === this.spiritId) || {};
    },
  },
  async created() {
    this.$emit('name', 'Item to spirit yield')
    if (this.$route.query.from && this.$route.query.to) {
      this.from = this.$route.query.from;
      this.to = this.$route.query.to;
    }

    await Promise.all([
      this.$lazyListLoad(this.categories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Item'}]),
      this.$lazyListLoad(this.items, 'items2', 'id,name,trackUnits,precision,category{id}', 100, [{field:'active', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(this.spirits, 'spirits2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}])
    ]);
    this.itemId = localStorage.getItem('reportsItemToSpirit.itemId') || (this.items.length ? this.items[0].id : null);
    this.spiritId = localStorage.getItem('reportsItemToSpirit.spiritId') || (this.spirits.length ? this.spirits[0].id : null);
    this.refresh();
  },
  methods: {
    saveParms() {
      this.from ? localStorage.setItem('reportsItemToSpirit.from', this.from) : localStorage.removeItem('reportsItemToSpirit.from');
      this.to? localStorage.setItem('reportsItemToSpirit.to', this.to) : localStorage.removeItem('reportsItemToSpirit.to');
      localStorage.setItem('reportsItemToSpirit.frequency', this.frequency);
      if (this.itemId)
        localStorage.setItem('reportsItemToSpirit.itemId', this.itemId);
      if (this.spiritId)
        localStorage.setItem('reportsItemToSpirit.spiritId', this.spiritId);
      this.refresh();
    },
    async refresh() {
      if (!this.itemId || !this.spiritId)
        return;
      this.loading = true;
      const results = await this.$apiCall(`query ReportsItemToSpirit($itemId:ID!,$spiritId:ID! $from:Date,$to:Date,$frequency:String!) {
                                             itemToSpiritReport(itemId:$itemId, spiritId:$spiritId, frequency:$frequency, from:$from,to:$to) {
                                                  period,quantity,volume
                                              }
                                            }`,
                                          {itemId:this.itemId,spiritId:this.spiritId,from:this.from,to:this.to,frequency:this.frequency});
      if (!results.error) {
        this.data = results.data.itemToSpiritReport;
        if (this.display === 1)
          this.buildGraph();
      }
      this.loading = false;
    },

    report() {
      if (this.loading)
        return '';
      const lines = [
                  `<style>
                    @page {size:portrait}
                    .report {font-family: Roboto, sans-serif; font-size:14px; width:100%;border-spacing:0}
                    .report th {height:36px;padding:0 16px}
                    .report td {height:36px;padding:0 16px}
                    .report .title {font-size:18px;text-transform:uppercase}
                    .report .sup-title {font-weight:normal;font-size:22px}
                    .report .sub-title {font-weight:normal;height:inherit;padding-bottom:20px}
                    .report .header th {border-bottom:1px solid #000;margin-bottom:20px}
                    .report .text-left {text-align:left}
                    .report .text-right {text-align:right}
                    .report .font-weight-bold {font-weight:bold}
                  </style>
                  <table class="report">
                     <thead>
                        <tr>
                          <th colspan="6" class="sup-title">${this.company.name}</th>
                        </tr>
                       <tr>
                        <th colspan="6" class="title">${this.item.name} to ${this.spirit.name} yield</th>
                      <tr>
                      <tr>
                         <th colspan="6" class="sub-title">${this.dateDisplay}</th>
                        </tr>
                      <tr class="header">
                        <th width="20%" class="text-left">${this.frequency}</th>
                        <th width="20%" class="text-right">${this.item.trackUnits} used</th>
                        <th width="20%" class="text-right">LAA produced</th>
                        <th width="20%" class="text-right">LAA/${this.item.trackUnits}</th>
                      </tr>
                    </thead>
                    <tbody>`];

      for (const line of this.data) {
        lines.push('<tr>');
        lines.push(`  <td>${this.frequency === 'Day' ? this.$formatDate(line.period) : line.period}</td>`);
        lines.push(`  <td class="text-right">${this.$number(line.quantity,this.item.precision)}</td>`);
        lines.push(`  <td class="text-right">${this.$number(line.volume,3)}</td>`);
        lines.push(`  <td class="text-right">${this.$number(line.quantity === 0 ? 0 : line.volume/line.quantity,3)}</td>`);
        lines.push('</tr>');
      }

      lines.push(`</tbody>`);
      lines.push(`</table>`);
      return lines.join('');
    },

    async buildGraph() {
      /*
      await this.loadGoogleCharts();
      if (!this.chart && window.google) {
        window.google.charts.load('current', {'packages':['corechart']});
        this.chart = await new Promise(resolve => {
          window.google.charts.setOnLoadCallback(() => {
            if (this.$refs.chart == undefined)
              resolve(null);
            resolve(new window.google.visualization.LineChart(this.$refs.chart))
          });
        });
      }
      if (this.chart) {
        const dataLineChart = [["Period","Total",{role:"tooltip",type:"string"},"avg",{role:"tooltip",type:"string"},"up",{role:"tooltip",type:"string"},"down",{role:"tooltip",type:"string"}]];
        const statistics = this.processStatistics.find(s => s.spiritId === this.graph);
        if (!statistics)
          return;
        const standardColumns = [statistics.mean,`Average ${statistics.mean}%`,statistics.mean+statistics.stdDev,`Standard deviation ${statistics.stdDev}%`,statistics.mean-statistics.stdDev,`Standard deviation ${statistics.stdDev}%`];
        for (const line of this.processPerformance) {
          const value = line.spirits.find(s => s.spiritId === this.graph).percent;
          const period = this.frequency === 'Daily' ? this.$formatDate(line.period) : line.period;
          const row = [period,value,`${period}\n${value}%`];
          dataLineChart.push(row.concat(standardColumns));
        }
        const data = window.google.visualization.arrayToDataTable(dataLineChart);
        this.options.hAxis.showTextEvery = Math.max(Math.round(this.processPerformance.length / 10), 1);
        this.chart.draw(data, this.options);
      }
*/
    },

    async print() {
      if (this.display === 0)
        this.printHtml('Item to spirits yield', this.report());
      else
        this.printHtml('Item to spirits yield',`<style>
                          @page {size:landscape}
                          body {font-family: Roboto, sans-serif; font-size:14px}
                          .title {font-weight:700;font-size:18px;text-align:center;width:100%}
                          .sub-title {text-align:center;margin-bottom:16px,width:100%}
                        </style>
                        <div class="title">${this.item.name} to ${this.spirit.name} yield</div>
                        <div class="sub-title">${this.dateDisplay}</div>
                        <img id="graph"/>`,
                        {id:'graph', src:this.chart.getImageURI()});
    },

    exportCSV() {
      const lines = [ `"${this.company.name}"`,
                      `"${this.item.name} to ${this.spirit.name} yield"`,
                      `"${this.dateDisplay}"`,
                    ];
      lines.push(`"${this.frequency}","${this.item.trackUnits} used","LAA produced","LAA/${this.item.trackUnits}"`);
      for (const line of this.data)
        lines.push(`"${this.frequency === 'Day' ? this.$formatDate(line.period) : line.period}",${line.quantity},${line.volume},${line.quantity === 0 ? 0 : line.volume/line.quantity}`);

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Item to spirit yield.csv');
    }
  }
}
</script>